import namespaceHelper from '@/shared/helpers/namespace-helper';
import { namespace, AlertMutations } from './types';

const _alertMutations = namespaceHelper.removeNamespace(namespace, AlertMutations);

export default {
  [_alertMutations.SET_ALERTS](state, alerts) {
    state.alerts = alerts;
  },
  [_alertMutations.SET_ALERTS_VIEWED](state, payload) {
    state.alerts
      .filter(al => al.alertDisplayTypeId == 2)
      .forEach(alert => {
        alert.isViewed = payload;
      });
  }
};
